// extracted by mini-css-extract-plugin
export default {"footer_modified":"Footer_footer_modified__Hllkd"};